/**
 * @file EditProfile.jsx
 * @description Interfaz principal de configuración de perfil de usuario
 */

import React, { useState } from "react";
import SkinPage from "../../SkinPage";
import Widget from "../Widget";
import { Grid } from "@mui/material";
import TextInput from "../../../../components/forms/TextInput";
import DateInput from "../../../../components/forms/DateInput";
import DgButton from "../../../../components/DgButton";
import { useForm } from "../../../../utils/useForm";
import "./../../../../styles/edit-profile.css";
import Request from "../../../../utils/fetchUtils";
import Swal from "sweetalert2";
import TwoFactorSetup from "../../../Authentication/TwoFactorSetup";
import TradierImport from "./TradierImport";
import PersonIcon from "@mui/icons-material/Person";

function EditProfile() {
  const user = JSON.parse(localStorage.session);
  const [loading, setLoading] = useState(false);

  const [data, setData] = useForm({
    fullName: user.fullName,
    birthday: "",
    ssn: "",
    phone: user.phone,
  });

  const [passData, setPassData] = useForm({
    password: "",
    newPassword: "",
  });

  // Estado para datos adicionales del usuario, comentados por ahora
  const [address] = useForm({
    street: user.address?.street ?? "",
    city: user.address?.city ?? "",
    zipCode: user.address?.zipCode ?? "",
    state: user.address?.state ?? "",
    country: user.address?.country ?? "",
  });

  const [financialInfo] = useForm({
    annualIncome: user.financialInfo?.annualIncome ?? "",
    netWorth: user.financialInfo?.netWorth ?? "",
    liquidNetWorth: user.financialInfo?.liquidNetWorth ?? "",
    source: user.financialInfo?.source ?? "",
  });

  const [employmentInfo] = useForm({
    employmentStatus: user.employmentInfo?.employmentStatus ?? "",
    employer: user.employmentInfo?.employer ?? "",
    employersAddress: user.employmentInfo?.employersAddress ?? "",
    occupation: user.employmentInfo?.occupation ?? "",
  });

  const now = new Date();
  const currentYear = now.getFullYear();
  const minimumBirthYear = currentYear - 18;

  // Opciones para selects (actualmente no utilizadas)
  const [myOptions] = useState([
    { value: "option-1", text: "Option 1" },
    { value: "option-2", text: "Option 2" },
    { value: "option-3", text: "Option 3" },
  ]);

  // Función para actualizar contraseña
  const updatePass = async () => {
    setLoading(true);
    const res = await Request(
      "user/change-pass",
      {
        accessToken: localStorage.getItem("accessToken"),
        ...passData,
      },
      "PATCH"
    );
    setLoading(false);
    if (res.ok) {
      Swal.fire("Success", res.message, "success");
    } else {
      Swal.fire("Error", res.message, "error");
    }
  };

  return (
    <SkinPage>
      <Widget name={"edit-profile"} width={"full-width"}>
        <div className="heading">
          <h1 className="title">Account Settings</h1>
        </div>        <div className="profile-pic">
          <div className="pic" style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            backgroundColor: '#95B2C5',
            borderRadius: '50%'
          }}>
            <PersonIcon sx={{ fontSize: 40, color: '#021C2D' }} />
          </div>
          <img className="edit" src="/assets/icons/pencil.svg" alt="" />
        </div>

        <TradierImport />
        
        <Grid container rowSpacing={4} columnSpacing={{ xs: 0, sm: 2, md: 12 }}>
          <Grid item xs={12} sm={6}>
            <div className="form-field">
              <TextInput
                customInput={{
                  label: "Full name",
                  name: "fullName",
                  value: data.fullName,
                  tooltipBool: false,
                  action: setData,
                  disabled: true,
                }}
              ></TextInput>
            </div>
            <div className="form-field">
              <DateInput
                customInput={{
                  label: "Date of birth",
                  name: "birthday",
                  value: data.birthday,
                  tooltipBool: true,
                  tooltipText: "You must be over 18 to create an account",
                  action: setData,
                  disabled: true,
                }}
                startingYear={1900}
                finishingYear={minimumBirthYear}
              ></DateInput>
            </div>
            <div className="form-field">
              <TextInput
                customInput={{
                  label: "Phone number",
                  name: "phone",
                  value: data.phone,
                  tooltipBool: false,
                  action: setData,
                  disabled: true,
                }}
              ></TextInput>
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <p className="title" style={{ color: "#95b2c5" }}>
              Change my password
            </p>
            <div className="form-field">
              <TextInput
                customInput={{
                  label: "Current Password",
                  name: "password",
                  value: passData.password,
                  action: setPassData,
                }}
              />
            </div>
            <div className="form-field">
              <TextInput
                customInput={{
                  label: "New Password",
                  name: "newPassword",
                  value: passData.newPassword,
                  action: setPassData,
                }}
                data={{}}
              />
            </div>
            <DgButton
              category={"primary"}
              size={"large"}
              text={"Change password"}
              action={updatePass}
              loading={loading}
            />
            {/*  <div className="form-field">
              <SelectInput
                customInput={{
                  label: "Employment status",
                  name: "employmentStatus",
                  value: employmentInfo.employmentStatus,
                  tooltipBool: false,
                  action: setEmploymentInfo,
                }}
                data={myOptions}
              ></SelectInput>
            </div>
            <div className="form-field">
              <TextInput
                customInput={{
                  label: "Employer's name",
                  name: "employer",
                  value: employmentInfo.employer,
                  tooltipBool: true,
                  tooltipText:
                    "The name of the company you are currently working for.",
                  action: setEmploymentInfo,
                }}
              ></TextInput>
            </div>
            <div className="form-field">
              <TextInput
                customInput={{
                  label: "Employer's address",
                  name: "employersAddress",
                  value: employmentInfo.employersAddress,
                  tooltipBool: true,
                  tooltipText:
                    "The address of the company you are currently working for.",
                  action: setEmploymentInfo,
                }}
              ></TextInput>
            </div>
            <div className="form-field">
              <TextInput
                customInput={{
                  label: "Occupation",
                  name: "occupation",
                  value: employmentInfo.occupation,
                  tooltipBool: true,
                  tooltipText: "Your current your job or profession.",
                  action: setEmploymentInfo,
                }}
              ></TextInput>
            </div>*/}
          </Grid>          <Grid item xs={12}>
            <div className="separator"></div>
          </Grid>
          
          {/* Two-Factor Authentication Section */}
            <Grid item xs={12}>
              <Widget name={"two-factor-auth"} width={"full-width"}>
                <div className="heading">
                  <h2 className="title">Two-Factor Authentication</h2>
                  <p style={{ color: "#8e8e93", marginBottom: "30px", fontSize: "16px", textAlign: "center" }}>Add an extra layer of security to your account</p>
                </div>
                <TwoFactorSetup onComplete={() => {}} showBackupCodes={true} />
              </Widget>
            </Grid>
          <Grid item xs={12}>
            <div className="separator"></div>
          </Grid>
          <Grid item xs={12} sm={6}>
            {/* <div className="form-field">
              <TextInput
                customInput={{
                  label: "Street",
                  name: "street",
                  value: address.street,
                  tooltipBool: false,
                  action: setAddress,
                }}
                data={myOptions}
              ></TextInput>
            </div>
            <div className="form-field">
              <div className="flex">
                <div className="city">
                  <TextInput
                    customInput={{
                      label: "City",
                      name: "city",
                      value: address.city,
                      tooltipBool: false,
                      action: setAddress,
                    }}
                    data={myOptions}
                  ></TextInput>
                </div>
                <div className="zip-code">
                  <TextInput
                    customInput={{
                      label: "Zip code",
                      name: "zipCode",
                      value: address.zipCode,
                      tooltipBool: false,
                      action: setAddress,
                    }}
                    data={myOptions}
                  ></TextInput>
                </div>
              </div>
            </div>
            <div className="form-field">
              <SelectInput
                customInput={{
                  label: "State",
                  name: "state",
                  value: address.state,
                  tooltipBool: false,
                  action: setAddress,
                }}
                data={myOptions}
              ></SelectInput>
            </div>
            <div className="form-field">
              <SelectInput
                customInput={{
                  label: "Country",
                  name: "country",
                  value: address.country,
                  tooltipBool: false,
                  action: setAddress,
                }}
                data={myOptions}
              ></SelectInput>
            </div> */}
          </Grid>
        </Grid>
      </Widget>
    </SkinPage>
  );
}

export default EditProfile;
